import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons';

function ImageToPdf() {
  const [images, setImages] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleImageUpload = (event) => {
    const files = event.target.files;
    const uploadedImages = [];
    const imagePromises = Array.from(files).map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });

    Promise.all(imagePromises)
      .then(results => {
        setImages(results);
      })
      .catch(err => {
        setError('An error occurred while reading images.');
      });
  };

  const generatePdf = async () => {
    if (images.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const pdfDoc = await PDFDocument.create();
      for (const image of images) {
        const imgBytes = await fetch(image).then(res => res.arrayBuffer());
        let img;
        if (image.includes('image/png')) {
          img = await pdfDoc.embedPng(imgBytes);
        } else if (image.includes('image/jpeg')) {
          img = await pdfDoc.embedJpg(imgBytes);
        } else {
          throw new Error('Unsupported image format.');
        }
        const { width, height } = img.scale(1);
        const page = pdfDoc.addPage([width, height]);
        page.drawImage(img, { x: 0, y: 0, width, height });
      }
      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (err) {
      setError(`An error occurred while generating the PDF: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="image-to-pdf">
      <h2>Image to PDF</h2>
      <label htmlFor="file-upload" className="file-upload-button">
        <FontAwesomeIcon icon={faFileUpload} /> Choose Images
        <input
          id="file-upload"
          type="file"
          multiple
          accept="image/*"
          onChange={handleImageUpload}
          style={{ display: 'none' }}
        />
      </label>
      <button onClick={generatePdf} disabled={loading} className="generate-pdf-button">
        <FontAwesomeIcon icon={faFilePdf} /> {loading ? 'Generating PDF...' : 'Generate PDF'}
      </button>
      {error && <p className="error">{error}</p>}
      {pdfUrl && (
        <a href={pdfUrl} download="images.pdf" className="download-link">
          <FontAwesomeIcon icon={faDownload} /> Download PDF
        </a>
      )}
    </div>
  );
}

export default ImageToPdf;
